import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { ThemeProvider } from "./contexts/ThemeContext.jsx";
import ThemeToggle from "./components/ThemeToggle.jsx";

const rootElement = document.getElementById("root");

if (rootElement) {
  try {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <ThemeProvider>
            <ThemeToggle />
            <App />
          </ThemeProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Failed to render React app:", error);

    rootElement.innerHTML = `
      <div style="padding: 2rem; text-align: center; color: #dc2626;">
        <h2>Application Failed to Load</h2>
        <p>Please refresh the page or check the console for errors.</p>
        <button onclick="window.location.reload()" style="padding: 0.5rem 1rem; margin-top: 1rem;">
          Reload Page
        </button>
      </div>
    `;
  }
} else {
  console.error("Root element not found!");
}
